import { z } from 'zod'

export const CustomerSchema = z
  .object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    email: z.string().optional(),
    phoneNumber: z.string().optional(),
  })
  .refine((data) => data.email || data.phoneNumber, {
    message: 'At least one of email or phone number is required',
    path: ['email', 'phoneNumber'],
  })

export type Customer = z.infer<typeof CustomerSchema>

export const ThemeFontSchema = z.object({
  font_family: z.string(),
  font_style: z.string().optional(),
  font_weight: z.number(),
  font_stretch: z.string().optional(),
  src: z.string(),
  font_format: z.string(),
})

export const ThemeSchema = z.object({
  primary_color: z.string().optional(),
  hover_color: z.string().optional(),
  button_text_color: z.string().optional(),
  font_family: z.string().optional(),
  fonts: z.array(ThemeFontSchema).optional(),
  modal_width: z.number().optional(),
  border_radius: z.number().optional(),
  button_radius: z.number().optional(),
  header_color: z.string().optional(),
  text_color: z.string().optional(),
  link_color: z.string().optional(),
  modal_padding: z.number().optional(),
  button_alignment: z.enum(['left', 'center', 'right', 'full']).optional(),
  text_alignment: z.enum(['left', 'center', 'right']).optional(),
  modal_image: z.string().optional(),
  modal_title: z.string().optional(),
  modal_message: z.string().optional(),
  modal_description: z.string().optional(),
  modal_button_text: z.string().optional(),
  show_expiration: z.boolean().optional(),
  partner_logo: z.string().optional(),
})

export type Theme = z.infer<typeof ThemeSchema>

export const InitOptionsSchema = z.object({
  clientId: z.string().min(1, 'Client ID is required'),
  customer: CustomerSchema,
  code: z.string().min(1, 'Referral code is required'),
  partnerName: z.string().optional(),
  environment: z.enum(['production', 'staging', 'development']).default('production'),
  countryCode: z.string().optional(),
  region: z.enum(['us', 'uk']).optional(), // deprecated: use countryCode instead
  apiEndpoint: z.string().url().optional(),
  skipOffer: z.boolean().optional(),
  showClose: z.boolean().optional(),
})

export type InitOptions = z.infer<typeof InitOptionsSchema>

export const ModalOptionsSchema = z.object({
  onClaim: z.function().optional(),
  onClose: z.function().optional(),
  onShow: z.function().optional(),
  onIneligible: z.function().optional(),
  onSelection: z.function().optional(),
})

export type ModalOptions = z.infer<typeof ModalOptionsSchema>

export const ApiErrorSchema = z.object({
  error: z.string(),
  message: z.string(),
  statusCode: z.number(),
})

export type ApiError = z.infer<typeof ApiErrorSchema>

export const GiftCertificateSchema = z.object({
  id: z.string(),
  code: z.string(),
  value: z.number(),
  expirationDate: z.string(),
})

export type GiftCertificate = z.infer<typeof GiftCertificateSchema>
